// paex-urgency-hero.js — Urgency Hero - PE (Halloween clock - PE, 2026-10-09).
// Swaps the server-rendered band (sections/paex-urgency-hero.liquid) to the
// shopper's state from window.paexClock (assets/paex-clock.js). Honest by
// construction: every day count, date, range and countdown comes from the
// clock; 'unknown' never gets a date or a range unless the destination is
// truly unknown (then the generic range, only while it still holds).
// Zero layout shift: the text box and the action slot keep their reserved
// heights (CSS); this file only swaps text and toggles visibility.
// paex-clock.js loads at the end of <body>, after this deferred script, so
// it starts on paex:clock-ready and follows paex:clock-change.

(function () {
  if (window.paexUrgencyHero) return;
  window.paexUrgencyHero = true;

  // tokens shown in brand orange + bold
  var EMPHASIS = { days: true, date: true, time: true, min: true, max: true };

  function clock() { return window.paexClock; }

  /* ---------------- text ---------------- */

  // Rebuilds el from a paex.clock.* template: plain text nodes for the copy,
  // a <span class="paex-uh__em"> per emphasised token (textContent only).
  // Returns the {time} span (or null) so the caller can bind the countdown.
  function setText(el, template, vars) {
    var old = el.querySelector('.paex-clock-cd');
    if (old && clock()) clock().unbind(old);
    el.textContent = '';
    var timeSpan = null;
    var pattern = /\{(\w+)\}/g;
    var last = 0;
    var match;
    var source = String(template || '');
    while ((match = pattern.exec(source))) {
      if (match.index > last) el.appendChild(document.createTextNode(source.slice(last, match.index)));
      var name = match[1];
      var value = vars && vars[name] != null ? String(vars[name]) : match[0];
      if (EMPHASIS[name]) {
        var span = document.createElement('span');
        span.className = 'paex-uh__em';
        span.textContent = value;
        el.appendChild(span);
        if (name === 'time') timeSpan = span;
      } else {
        el.appendChild(document.createTextNode(value));
      }
      last = pattern.lastIndex;
    }
    if (last < source.length) el.appendChild(document.createTextNode(source.slice(last)));
    return timeSpan;
  }

  /* ---------------- pieces ---------------- */

  // both labels are server-rendered in one grid cell (the shop label may be
  // the section's own "Button label"); this only toggles which one shows
  function setPrimary(root, kind) {
    var c = clock();
    var link = root.querySelector('[data-uh-primary]');
    if (!link) return;
    var storesUrl = String((c.config && c.config.storesUrl) || '').trim();
    var stores = !!(kind === 'stores' && storesUrl);
    // no store label set (section setting empty): the shop label stays
    var storeLabel = link.querySelector('[data-uh-label="stores"]');
    if (stores && storeLabel && !storeLabel.textContent.trim()) stores = false;
    link.querySelectorAll('[data-uh-label]').forEach(function (label) {
      label.classList.toggle('is-off', (label.dataset.uhLabel === 'stores') !== stores);
    });
    var href = stores ? storesUrl : root.dataset.shopUrl;
    if (href && link.getAttribute('href') !== href) link.setAttribute('href', href);
  }

  // section settings: {season} name and the optional occasion-day message
  function withSeason(root, vars) {
    var out = { season: root.dataset.season || 'Halloween' };
    Object.keys(vars || {}).forEach(function (key) { out[key] = vars[key]; });
    return out;
  }
  function dayTemplate(root) {
    return root.dataset.dayText || clock().t('hero_day');
  }

  // which = 'date' | 'store' | 'loc' | 'none' — one slot, one visible item
  function setSlot(root, which, state) {
    if (which === 'loc' && root.dataset.showLoc !== 'true') which = 'none';
    var place = root.querySelector('[data-uh-place]');
    if (which === 'loc' && place) {
      var label = (state.destination && state.destination.label) || '';
      if (!label) which = 'none';
      else if (place.textContent !== label) place.textContent = label;
    }
    var items = { date: '[data-uh-date]', store: '[data-uh-store]', loc: '[data-uh-loc]' };
    Object.keys(items).forEach(function (key) {
      var el = root.querySelector(items[key]);
      if (el) el.classList.toggle('is-off', key !== which);
    });
  }

  /* ---------------- states ---------------- */

  // "Visit {store} today" only on data: the chosen store's full record (the
  // header chip's pool) says it is open now or opens later today — the same
  // hours gate as assets/paex-sticky-delivery.js. No record, no hours, closed
  // all day or already closed → '' (the generic wording, no store named).
  // The hours are read on the device clock, so an untrusted clock names none.
  function openTodayName(store, trusted) {
    if (trusted === false) return '';
    if (!store || !store.id || typeof paexStoreHoursInfo !== 'function') return '';
    var chip = document.querySelector('paex-store-chip');
    var stores = chip && chip.data && chip.data.stores;
    var full = stores && stores[store.id];
    if (!full) return '';
    var info = paexStoreHoursInfo(full);
    var open = info && (info.state === 'open' || info.state === 'closes_soon' || info.nextOpenIsToday);
    return open ? store.name || '' : '';
  }

  // late, eve (no delivery promise left) and day: stores wording + Find a store
  function renderStores(root, text, state) {
    var c = clock();
    var store = state.store;
    var template;
    var name = '';
    if (state.phase === 'day') template = dayTemplate(root);
    else {
      name = openTodayName(store, state.trusted);
      template = name ? c.t('hero_late') : c.t('hero_late_generic');
    }
    // remembered so the minute tick re-checks the hours (a store that just
    // closed stops being named without waiting for a clock-change)
    if (state.phase !== 'day') root.dataset.uhStores = name || '-';
    setText(text, template, withSeason(root, { store: name }));
    setPrimary(root, 'stores');
    if (store) setSlot(root, 'store', state);
    else if (state.phase === 'day') setSlot(root, 'none', state);
    else setSlot(root, state.destination && state.destination.source !== 'none' ? 'loc' : 'none', state);
  }

  function render(root, state) {
    var c = clock();
    var text = root.querySelector('[data-uh-text]');
    if (!c || !state || !text) return;
    delete root.dataset.uhStores;

    // end of season (page left open / cached across Nov 1): nothing to say,
    // but the band keeps its reserved box so the slideshow below never jumps
    var ended = state.phase === 'off';
    root.classList.toggle('is-ended', ended);
    if (ended) {
      root.setAttribute('aria-hidden', 'true');
      var cd = text.querySelector('.paex-clock-cd');
      if (cd) c.unbind(cd);
      return;
    }
    root.removeAttribute('aria-hidden');

    // geo still answering (≤ 3 s): keep the server's generic first paint
    if (state.pending && state.phase === 'countdown') return;

    if (state.phase === 'day' || state.phase === 'eve' || state.verdict === 'late') {
      renderStores(root, text, state);
      return;
    }

    var occasion = (c.config && c.config.occasion) || {};
    var closeDays = Number(occasion.closeDays) || 16;
    var days = state.days;

    if (state.verdict === 'lastday') {
      var timeSpan = setText(text, c.t('hero_last'), withSeason(root, { time: '' }));
      var sr = document.createElement('span');
      sr.className = 'visually-hidden';
      text.appendChild(sr);
      var bound = timeSpan && c.bindCountdown(timeSpan, { srEl: sr });
      // no live countdown = the cutoff just passed (or the device clock is
      // off): "order today, get it {date}" may no longer hold, so the day
      // count only until the clock's next refresh re-decides the verdict
      if (!bound) setText(text, c.t('hero_days'), withSeason(root, { days: days }));
      setPrimary(root, 'shop');
      setSlot(root, 'loc', state);
      return;
    }

    if (state.verdict === 'ontime') {
      setText(text, days > closeDays ? c.t('hero_far') : c.t('hero_close'), withSeason(root, { days: days, date: state.dateLabel }));
      setPrimary(root, 'shop');
      setSlot(root, 'loc', state);
      return;
    }

    // 'unknown'. A KNOWN destination with no honest date (remote postal
    // code, US, outside the transit table) gets the day count only — the
    // generic range would be a false promise for it.
    var known = state.destination && state.destination.source !== 'none';
    var range = state.range;
    if (!known && range && range.allLate) {
      renderStores(root, text, state);
      return;
    }
    if (!known && range && !range.someLate) {
      setText(text, c.t('hero_unknown'), withSeason(root, { days: days, min: range.min, max: range.max }));
    } else {
      setText(text, c.t('hero_days'), withSeason(root, { days: days }));
    }
    setPrimary(root, 'shop');
    setSlot(root, known && root.dataset.showLoc === 'true' ? 'loc' : 'date', state);
  }

  /* ---------------- wiring ---------------- */

  function bindRoot(root) {
    if (root.dataset.uhBound) return;
    root.dataset.uhBound = 'true';
    var storeButton = root.querySelector('[data-uh-store]');
    if (storeButton) {
      storeButton.addEventListener('click', function () {
        // the header store chip owns the drawer; no chip → no button
        if (!clock() || !clock().openStoreDrawer()) storeButton.classList.add('is-off');
      });
    }
  }

  function renderAll(state) {
    document.querySelectorAll('[data-paex-uh]').forEach(function (root) {
      bindRoot(root);
      render(root, state);
    });
  }

  function start() {
    renderAll(clock().state);
    document.addEventListener('paex:clock-change', function (event) {
      renderAll(event.detail || clock().state);
    });
    // late wording names a store only while it is open today: re-decide on
    // the minute tick, and only when the named/generic choice would change
    document.addEventListener('paex:clock-minute', function () {
      var c = clock();
      if (!c || !c.state) return;
      document.querySelectorAll('[data-paex-uh][data-uh-stores]').forEach(function (root) {
        var now = openTodayName(c.state.store, c.state.trusted) || '-';
        if (now !== root.dataset.uhStores) render(root, c.state);
      });
    });
    // theme editor: a re-rendered section gets the current state at once
    document.addEventListener('shopify:section:load', function () {
      if (clock()) renderAll(clock().state);
    });
  }

  if (window.paexClock) start();
  else document.addEventListener('paex:clock-ready', start, { once: true });
})();
